import ApiWrapper from "./baseAPI"; // Import the base API wrapper
import { AtomAPIResponse } from "../model/atomAPIResponse"; // Import the VehicleDetails model
import apiConfig from "../apiConfig";

class AtomAPI extends ApiWrapper {
  constructor() {
    const headers = {
      apiKey: apiConfig.API_KEY,
    };
    super(apiConfig?.atomAPI, 10000, null, headers);
  }

  // Method to fetch property details by address1 and address2, returning a strongly typed object
  async fetchPropertyDetails(
    houseNumber: string,
    streetAddress: string,
    city: string,
    state: string,
    zip: string,
    country: string,
    vendorId: string
  ): Promise<AtomAPIResponse> {
    // put mandatory conditions to check
    try {
      // Query parameters
      const params = {
        houseNumber,
        streetAddress,
        city,
        state,
        zip,
        country,
        vendorId,
      };

      // Make GET request for vehicle details using the inherited `get` method
      const propertyDetails = await this.get<AtomAPIResponse>(
        "",
        params,
        10000
      );
      return propertyDetails;
    } catch (error) {
      console.error(
        "Failed to fetch property details from Digital Orchestration:",
        error
      );
    }
  }
}

export default AtomAPI;
